import { deleteDashboardData } from '../../../indexedDb/dashboard'
import { deleteAllFleets } from '../../../indexedDb/fleets'
import { deleteAllPendingEvents } from '../../../indexedDb/pendingEvents'
import { deleteAllPendingRequests } from '../../../indexedDb/pendingRequests'
import { deleteAllPMWorkOrders } from '../../../indexedDb/pmWorkOrders'
import { deleteAllRequests } from '../../../indexedDb/requests'
import { deleteAllRequestDetails } from '../../../indexedDb/requestsDetails'
import { deleteAllReviewRequests } from '../../../indexedDb/reviewRequests'

// Utility function to delete all data in IndexedDB
export async function deleteAllData(deleteFunctions) {
    try {
        for (const deleteFunc of deleteFunctions) {
            await deleteFunc()
        }
        console.log('All data deleted successfully')
    } catch (error) {
        console.error('Error deleting data:', error)
        throw error
    }
}

export async function deleteAllDashboardData() {
    await deleteAllData([
        deleteDashboardData,
        deleteAllFleets,
        deleteAllPendingEvents,
        deleteAllPendingRequests,
        deleteAllPMWorkOrders,
        deleteAllRequests,
        deleteAllRequestDetails,
        deleteAllReviewRequests,
    ])
}
